/**
 * Bundle Accordion - Generic Web Component
 * Standard native HTML Custom Element extending HTMLElement
 * Common reusable accordion component for What's In This Bundle and Scent Notes
 */

if (!customElements.get('bundle-accordion')) {
  class BundleAccordion extends HTMLElement {
    constructor() {
      super();
      this.toggleAccordion = this.toggleAccordion.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    connectedCallback() {
      this.headerButton = this.querySelector('[data-accordion-header], .whats-in-bundle-header, .bundle-notes-header, button');
      this.panel = this.querySelector('[role="region"], .whats-in-bundle-body, .bundle-notes-body');
      if (this.headerButton) {
        this.headerButton.addEventListener('click', this.toggleAccordion);
        this.headerButton.addEventListener('keydown', this.handleKeyDown);
        const isOpen = this.hasAttribute('open');
        this.headerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (this.panel) this.panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
    }

    disconnectedCallback() {
      if (this.headerButton) {
        this.headerButton.removeEventListener('click', this.toggleAccordion);
        this.headerButton.removeEventListener('keydown', this.handleKeyDown);
      }
    }

    toggleAccordion() {
      const isOpen = this.hasAttribute('open');
      if (isOpen) {
        this.removeAttribute('open');
        if (this.headerButton) {
          this.headerButton.setAttribute('aria-expanded', 'false');
          this.headerButton.focus();
        }
        if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
      } else {
        const isSingleOpen = this.hasAttribute('data-single-open');
        if (isSingleOpen) {
          const containerSelector = this.getAttribute('data-single-open-container') || '.bundle-grid-container';
          const container = this.closest(containerSelector) || this.parentElement;
          if (container) {
            const siblingSelector = `${this.tagName.toLowerCase()}[open], bundle-accordion[open]`;
            const otherOpen = container.querySelectorAll(siblingSelector);
            otherOpen.forEach(el => {
              if (el !== this) {
                el.removeAttribute('open');
                const btn = el.querySelector('[data-accordion-header], .whats-in-bundle-header, .bundle-notes-header, button');
                const pnl = el.querySelector('[role="region"], .whats-in-bundle-body, .bundle-notes-body');
                if (btn) btn.setAttribute('aria-expanded', 'false');
                if (pnl) pnl.setAttribute('aria-hidden', 'true');
              }
            });
          }
        }

        this.setAttribute('open', '');
        if (this.headerButton) {
          this.headerButton.setAttribute('aria-expanded', 'true');
          this.headerButton.focus();
        }
        if (this.panel) this.panel.setAttribute('aria-hidden', 'false');
      }
    }

    handleKeyDown(event) {
      if (event.key === ' ' || event.key === 'Enter') {
        if (this.headerButton && this.headerButton.tagName !== 'BUTTON') {
          event.preventDefault();
          this.toggleAccordion();
        }
      }
    }
  }

  customElements.define('bundle-accordion', BundleAccordion);

  // Register aliases for backward compatibility with existing Liquid templates
  if (!customElements.get('whats-in-bundle')) {
    customElements.define('whats-in-bundle', class extends BundleAccordion {});
  }
  if (!customElements.get('bundle-scent-notes')) {
    customElements.define('bundle-scent-notes', class extends BundleAccordion {});
  }
}
